
import { Injectable, NgZone } from '@angular/core';
import { get, DeviceCommunicationService } from '@ubie/client-core';
import { SipDevicesService, Functionblock, LogService } from '@ubie/core';
import { UbieSipConfiguration } from '@ubie/sip-configuration';
import { environment } from 'src/environments/environment';

@Injectable()
export class SipHelper {

    private sipStarted = false;

    constructor(
        private sipDeviceService: SipDevicesService,
        private communication: DeviceCommunicationService,
        private logger: LogService,
        private ngZone: NgZone
    ) { }


    /////////////////////////////////////////////////////////
    //#region SIP PROPERTIES
    /////////////////////////////////////////////////////////

    currentDeviceUid: string;
    storageKey = 'sipDeviceUid';
    incomingCall = false;
    private token;

    //#endregion
    /////////////////////////////////////////////////////////


    //#region SIP

    public initSip() {

        this.ngZone.runOutsideAngular(async () => {

            this.logger.info('SIP-HELPER - init sip');

            // get the current device uid
            this.currentDeviceUid = await get(this.storageKey);

            this.logger.info("SIP-HELPER - current device uid", this.currentDeviceUid);

            // if the device has a sip device uid, we need to initialize SIP in the java part of the application
            if (this.currentDeviceUid !== null && this.currentDeviceUid !== undefined && this.currentDeviceUid !== 'popupClosed') {
                this.logger.info('SIP-HELPER - init sip getSipDevice');
                this.getSipDevice();
            } else {
                // if sip was running (check in java), stop sip
                this.logger.info('SIP-HELPER - init sip stopSipOnDevice');
                this.stopSipOnDevice();
            }

            UbieSipConfiguration.requestPermissions().then(x => {
                  console.log("permision: " + x.camera);
                  console.log("permision: " + x.microphone);
            });

        });
    }

    public async setPushNotificationToken(value) {
        this.logger.info('SIP-HELPER - SipHelper, set token ', value);
        this.token = value;
    }

    /**
     * Get sip device
     */
    private getSipDevice() {
        // fetch data
        this.sipDeviceService.getSipDeviceConfig(this.currentDeviceUid).subscribe({
          next:  (data) => {
                this.logger.info('SIP-HELPER - getSipDevice data', data);

           

                if (data.fullExtension !== null && data.fullExtension !== undefined &&
                    data.password !== null && data.password !== undefined &&
                    data.domain !== null && data.domain !== undefined) {
                    this.ngZone.run(() => this.startSipOnDevice(data));
                } else {
                    // the device is still in the database but is not linked to a doorbell
                    this.ngZone.run(() => this.stopSipOnDevice());
                }

            },
           error: (error) => {
                this.logger.error('SIP-HELPER - getSipDevice error', error);

            }
        });
    }

    /**
     * Start SIP on device
     */
    private startSipOnDevice(data) {

        this.logger.debug('start sip on device ' + this.sipStarted);

        // start sip
        if (!this.sipStarted) {
            console.log('startSipOnDevice - a', data);

            UbieSipConfiguration.startSip(
                { isDevelop: !environment.production, domain: data.domain, extension: data.user.id.toString() + data.extension.toString(), password: data.password, token: this.token }).then(() => this.logger.info('start sip on device sent'));

        }

        console.log('startSipOnDevice - b');


        // do not add listeners if sip was already started
        if (!this.sipStarted) {
            console.log('sipStarted - add listeners');

            // listen for functionblock clicked event
            UbieSipConfiguration.addListener('functionblockClicked', (result: any) => {
                console.log('functionblockClicked ', result);
                this.handleFunctionblockClicked(result);
            });

            // listen for log event
            UbieSipConfiguration.addListener('onLog', (result: any) => {
                console.log('On Log Received ', result);
                if (result.hasOwnProperty("message")) {
                    if (result.hasOwnProperty("level")) {
                        switch (result.level) {
                            case "debug": {
                                this.logger.debug(result.message);
                                break;
                            }
                            case "info": {
                                this.logger.info(result.message);
                                break;
                            }
                            case "warn": {
                                this.logger.warn(result.message);
                                break;
                            }                            
                        }
                    }
                    else {
                        this.logger.info(result.message);
                    }
                }
            });

            // listen for incoming call event
            UbieSipConfiguration.addListener('incomingCallReceived', (result: any) => {
                console.log('Incoming call received ', result);
                this.handleIncomingCall(result);
            });

            // listen for incoming call event
            UbieSipConfiguration.addListener('incomingCallReleased', (result: any) => {
                console.log('(incoming) call released ', result);
                this.incomingCall = false;
            });
        }

        console.log('startSipOnDevice - c');

        this.sipStarted = true;
    }

    private setCallerDetails(name: string, fb: Functionblock) {
        UbieSipConfiguration.setCallerDetails(
            { name: name, functionblock: fb }).then(() => this.logger.info("SIP-HELPER - set called details finished"));
    }

    /**
     * A push notification token was received
     */
    public pushnotificationTokenReceived(token: string) {
        // UbieSipConfiguration.setPushnotificationToken(
        //     { token: token });
    }

    /**
     * Stop SIP on device
     */
    public stopSipOnDevice() {
        UbieSipConfiguration.stopSip().then(() => {
            this.sipStarted = false;
            this.logger.error("SIP-HELPER - stopped sip")
        });

        
    }

    /**
     * Check if the call is still active
     * When a call rings, we set a boolean = true, when a call is released, we set the boolean = false
     */
    public async isCallActive(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            if (this.incomingCall) {
                resolve(this.incomingCall);
                this.incomingCall = false;
            }
            else {
                // timeout is needed for iOS, when the app is inactive:
                // it takes some time for linphone to start up and process the incoming call
                setTimeout(() => {
                    resolve(this.incomingCall);
                    this.incomingCall = false;
                }, 2000);
            }
        });
    }

    private handleIncomingCall(data: any) {
        this.logger.info('SIP-HELPER - Handle incoming call', data);
        if (data !== null && data !== undefined) {
            if (data.hasOwnProperty('call')) {
                this.incomingCall = true;
                // get caller details from database
                this.getSipDeviceByExtenion(data.call);
            }
        }
    }

    /**
         * Get sip device
         */
    private getSipDeviceByExtenion(extension: string) {
        // fetch data
        this.sipDeviceService.getSipDeviceByExtension(extension).subscribe(
            (data) => {
                const name = data.hasOwnProperty('name') ? data.name : '';
                const fb = data.hasOwnProperty('functionblock') ? data.functionblock : null;
                this.setCallerDetails(name, fb);
            },
            (error) => {
            }
        );
    }

    /**
         * Functionblock was clicked in the call screen
         * @param data 
         */
    private handleFunctionblockClicked(data: any) {
        if (data !== null && data !== undefined) {

            if (data.hasOwnProperty('deviceSerialNumber') &&
                (data.hasOwnProperty('networkDeviceSerialNumber')) &&
                (data.hasOwnProperty('functionblockSerialNumber')) &&
                (data.hasOwnProperty('functionblockType'))) {
                // if the output type is ONOFF --> perform ON action
                if (data.functionblockType.toString().toLowerCase() === 'onoff') {
                    this.communication.setFunctionBlockAction(
                        'on',
                        data.deviceSerialNumber, // device sn
                        data.networkDeviceSerialNumber, // networkdevice sn,
                        data.functionblockSerialNumber // functionblock sn
                    );
                } else {
                    // if the output type is SCENE --> perform ACTIVE action
                    if (data.functionblockType.toString().toLowerCase() === 'scene') {
                        this.communication.setFunctionBlockAction(
                            'active',
                            data.deviceSerialNumber, // device sn
                            data.networkDeviceSerialNumber, // networkdevice sn,
                            data.functionblockSerialNumber // functionblock sn
                        );
                    }
                }
            }

        }
    }

    //#endregion

}